import React, { useEffect, useState } from "react";
// import './style.css';
import { Layout, Spin, Table, Button, Space,DatePicker, Input, Row, Col, Modal,  Dropdown, Menu, Popconfirm } from 'antd';
import {
    PlusOutlined, SearchOutlined, SyncOutlined, MoreOutlined, DeleteOutlined
} from '@ant-design/icons';
import { Link, useHistory, Redirect } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { getAllCollaborateDoc, clerkCollaborateDocSelector,DeleteProcessAsyn, clearState, } from './CollaborateDocumentSlice';
import ability from '../../../config/ability';
import Container from '../../Layout/Container';
import moment from 'moment';
import {logout, authSelector} from '../../Auth/authSlice';
import '../CollaborateDocument/CollaborateDocument.css'
const { Header, Content, Footer } = Layout;
const { Search } = Input;
const ntop = "none";
const nbottom = "bottomCenter";
const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;
const { confirm } = Modal;

export default function CollaborateDocument() {

    const { user } = useSelector(
        authSelector
      );
      const loggedInUser = user.username ;

    const dispatch = useDispatch();
    let history = useHistory()
    const [isLoading, setLoading] = React.useState(false);
    const { isFetching, isAllCollaborateSuccess, isError, errorMessage, AllCollaborateData, collaborateCount } = useSelector(
        clerkCollaborateDocSelector
    );

    const [AllCollaborateDoc, setDataSource] = useState([]);
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState('');

    // In the fifth row, other columns are merged into first column
    // by setting it's colSpan to be 0
    const renderContent = (value, row, index) => {
        const obj = {
            children: value,
            props: {},
        };
        // if (index === 4) {
        //   obj.props.colSpan = 0;
        // }
        return obj;
    };

    const columns = [
        {
            title: 'Document Id',
            dataIndex: 'doc_id',
            render: renderContent,
        },
        {
            title: 'Document Name',
            dataIndex: 'doc_name',
            render: renderContent,
        },
        {
            title: 'Created On',
            dataIndex: 'created_on',
            render: renderContent,
        },
        {
            title: 'Created By',
            dataIndex: 'created_by',
            render: renderContent,
        },
        {
            title: 'ACTION',
            dataIndex: 'action',
            render: (text, row, index) => {
                return {
                    children: <a onClick={(e) => handleProcessClick(row, e)}>View Document</a>
                };
            },
        },

        {
            title: 'Remove',
            dataIndex: 'action',
            render: (text, row, index) => {
                return {
                    children: <a onClick={(e) => showConfirm(row, e)}>
                         {/* <Button className={'tblbtnClass'}   icon={<DeleteOutlined />} size={'middle'} danger/> */}
                         <Button 
//   className={'tblbtnClass'} 
  icon={<DeleteOutlined />} 
  size={'middle'} 
  disabled={row.created_by !== loggedInUser}
/>
                     </a>
                };
            },
        },

    ];



    useEffect(() => {
        setLoading(true);
        dispatch(clearState());
        dispatch(getAllCollaborateDoc('&page=' + page));
    }, []);

    useEffect(() => {

        if (isError) {
            setLoading(false);

            toast.error(errorMessage);
        }
        if (isAllCollaborateSuccess) {
            setLoading(false);
            setDataSource(AllCollaborateData);
        }
    }, [isError, isAllCollaborateSuccess, setLoading, AllCollaborateData, setDataSource]);

    const showConfirm = (row,e) => {
        console.log(row,"row")
        confirm({
          title: 'This would be removed',
          // icon: <ExclamationCircleFilled />,
          // content: 'Clicking OK would automatically log document and all changes in real-time.',
          onOk() {
            const data = {"id":row.id}
        e.preventDefault();
        // console.log(e.key + " row = " + row.action);
        dispatch(DeleteProcessAsyn(data));
        setTimeout(() => {
            dispatch(getAllCollaborateDoc('&page=' + page));
        }, 100);
      
            
            console.log('OK');
          },
          onCancel() {
            console.log('Cancel');
          },
        });
      };
    const handleProcessClick = (row, e) => {
        //  console.log("click", row, "e", e);   
        history.push({
            pathname: '/new-document',
            state: { roomId: row.action }
        });

    }

    const ChangeDraftPagination = (v) => {

        if (search) {
            let q = '&page=' + v.current + '&search=' + search;
            dispatch(getAllCollaborateDoc(q)).then(res => {

                if (res) {
                    let udata = res.payload.data.data;
                    setDataSource(udata);
                    setPage(v.current);
                }
            });
        }
        else {
            setPage(v.current);
            dispatch(getAllCollaborateDoc('&page=' + v.current));
        }
    }

    let dataSource = isLoading
    ? []
    : AllCollaborateDoc && AllCollaborateDoc.data ? AllCollaborateDoc.data.map(row => ({
        id: row._id,
        doc_id: row.docId,
        doc_name: row.docName,
        action: row.roomId,
        created_on: moment(row.created_at).format("ll"),
        created_by: row.owner,
    })) : [];


    let onDateChange = (value, dateString) => {
 
        // console.log('Selected Time: ', moment(value).format());
        //  let data = `isStatus=${currentTab}&date=2021-09-16T07:27:14.194+00:00`;
        //    2021-09-21T00: 00: 00 + 05: 30
        if (dateString) {
            // console.log('Formatted Selected Time: ', moment(dateString).format('YYYY-MM-DD'));
         
      
      let mydate = `${moment(dateString).format('YYYY-MM-DD')}`;
      //let test = '2022-10-31T21:31:25.029Z';
      console.log(mydate,'mydate');
    
      
        //     let filteredData =  AllCollaborateData.data.filter(function(item) {
        //       return item.created_at.includes(mydate);
             
        //   });
      
        //  setDataSource(filteredData)
         // console.log(filteredData,'ndate')
         // setPage(1);


     
            let q = '&page=' + page + '&search=' + '00000!date'+mydate;
            dispatch(getAllCollaborateDoc(q)).then(res => {
                if (res) {
                    let udata = res.payload.data.data;
                    setDataSource(udata);
                  
                }
               
            });
     
      

      
      
        }
        else {
            dispatch(getAllCollaborateDoc('&page=' + page));
        
        }
      
      }

    return (
        <>
            <Container>

                <Spin indicator={antIcon} style={{ textAlign: 'center', width: '100%' }} spinning={isLoading} />
                {/* <div className="site-layout-content" style={{marginTop:35,marginBottom:35,border:"1px solid #dfe0eb"}}> */}
                <div className="site-layout-content" style={{ marginTop: 5 }}>
                    <div style={{ padding: 24, paddingTop: 16 }}>
                        <h2 style={{ paddingLeft: 16, paddingTop: 20, borderTop: '1px solid #dfe0eb', borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb', marginBottom: 0, backgroundColor: '#ffffff' }}>Collaboration Document ({collaborateCount ? collaborateCount : 0})</h2>
                        <Space style={{ padding: 16, width: '100%', borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb', backgroundColor: '#ffffff' }} size="large">
                            <Row style={{ width: '100%' }}>
                                <Col span="10">
                                <div style={{display:'flex', justify:'space-between'}}>
                                <Input placeholder="Search by Document ID, Name and date" size="large" suffix={<SearchOutlined />}

onChange={e => {
    const currValue = e.target.value;
    setSearch(currValue);

    
// if (currValue) {
//     //console.log(AllCollaborateData,'filtered data')
//     let filteredData =  AllCollaborateData.data.filter(item => item.docName.toLowerCase().includes(search) 
//     || item.docId.toLowerCase().includes(search));
//     console.log(filteredData,'filtered data')
//  setDataSource(filteredData);

//  setPage(1);

// }




    if (currValue) {
        let q = '&page=' + page + '&search=' + currValue;
        dispatch(getAllCollaborateDoc(q)).then(res => {

            if (res) {
              
                let udata = res.payload.data.data;
                console.log(udata, 'theres');
                setDataSource(udata);
                setPage(1);
            }
        });
    }
    else {

        let q = '&page=' + 1 + '&search=' + '';
        dispatch(getAllCollaborateDoc(q)).then(res => {

            if (res) {
              
                let udata = res.payload.data.data;
                console.log(udata, 'theres');
                setDataSource(udata);
                setPage(1);
            }
        });
    }

}}

/>

<DatePicker 
 onChange={onDateChange} 
style={{marginLeft:'4px'}} 
 
 size="large" format={'ll'} />
</div>

                                </Col>
                                <Col span="14" style={{ textAlign: 'right' }}>
                                    <Space>
                                        {/* {ability.can('allProcessTab', 'manage/editTemplates') &&
                      <Link to="/manage-template"><Button size="large" style={{ borderRadius: 5, padding: '6.4px 8px', fontWeight: 600, fontSize: 14 }} type="primary" ghost>Manage Template</Button></Link>
                    } */}
                                        {/* <Link to="/manage-template"><Button size="large" style={{borderRadius:5,padding:'6.4px 8px',fontWeight:600,fontSize:14}}  type="primary" ghost>Manage Template</Button></Link> */}
                                        {/* {ability.can('allProcessTab', 'createTemplates') &&
                      <Link to="/new-template"><Button size="large" style={{ borderRadius: 5, padding: '6.4px 8px', fontWeight: 600, fontSize: 14 }} type="primary" icon={<PlusOutlined />}>New Template</Button></Link>
                    } */}
                                    </Space>
                                </Col>
                            </Row>
                        </Space>

                        <Table
                            columns={columns}
                            onChange={ChangeDraftPagination}
                            pagination={{
                                position: [ntop, nbottom],
                                size: "small",
                                defaultPageSize: 10,
                                total: collaborateCount ? collaborateCount : 0,
                                hideOnSinglePage: true,
                            }}
                            dataSource={dataSource}
                            className="clerk-all-process-table collaborate-document-table"
                            bordered
                        />


                    </div>

                </div>
            </Container>
        </>
    );
}
